// extracted by mini-css-extract-plugin
export default {"wrapper":"input_wrapper__So0KE","label":"input_label__GO2Xi","input":"input_input__-IENe"};